<div class="row mt-md-0 mt-5">
  <div class="col-12">
    <h4 *ngIf="showTitle" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.TITLE"></h4>
    <div class="alert alert-info {{ showTitle ? 'my-3' : 'my-0 p-4' }}">
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.INTRO"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.INTRO"></p>
      <ul>
        <li jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.ARRAY.COLUMN_1"></li>
        <li jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.ARRAY.COLUMN_2"></li>
        <li jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.ARRAY.COLUMN_3"></li>
        <li jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.ARRAY.COLUMN_4"></li>
      </ul>
      <p>
        <ng-container *ngIf="!isKmUnit()"
          ><span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.PARAGRAPH_1_1"></span
          ><span jhiTranslate="{{ 'MEASURE_UNIT.' + getMeasureUnit()?.toUpperCase() }}"></span></ng-container
        ><span *ngIf="isKmUnit()" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.PARAGRAPH_1_2"></span
        ><span *ngIf="!isRangePricing()" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.PARAGRAPH_2_1"></span
        ><span *ngIf="isRangePricing()" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.PARAGRAPH_2_2"></span>
      </p>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.PARAGRAPH_3"></p>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT.PARAGRAPH_4"></p>
      <div class="h5">
        <mdb-icon fas icon="info-circle" class="info-text pr-2" aria-hidden="true"></mdb-icon>
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.FILE_FORMAT_EXAMPLE.TITLE"></span>
      </div>
      <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
        <tr class="bg-main">
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_1"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_2"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_3"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_4"></th>
          <ng-container *ngIf="!isRangePricing(); else rangePricing1">
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
          </ng-container>
          <ng-template #rangePricing1>
            <ng-container *ngIf="!isLDMUnit(); else LDMUnit1">
              <th>0-50</th>
              <th>51-100</th>
              <th>101-150</th>
              <th>151-200</th>
              <th>201-300</th>
              <th>301-400</th>
              <th>401-550</th>
            </ng-container>
            <ng-template #LDMUnit1>
              <th>0-0.4</th>
              <th>0.5-1.2</th>
              <th>1.3-2.4</th>
              <th>2.5-3.6</th>
              <th>3.7-4.8</th>
              <th>4.9-6</th>
              <th>6.1-7.2</th>
            </ng-template>
          </ng-template>
        </tr>
        <tr>
          <td>FR</td>
          <td>33700</td>
          <td>FR</td>
          <td>75000</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit1">
            <th>11,11</th>
            <th>22,22</th>
            <th>33,33</th>
            <th>44,44</th>
            <th>55,55</th>
            <th>66,66</th>
            <th>77,77</th>
          </ng-container>
          <ng-template #KmUnit1>
            <th>2,40</th>
            <th>2,35</th>
            <th>2,20</th>
            <th>2,10</th>
            <th>1,90</th>
            <th>1,80</th>
            <th>1,60</th>
          </ng-template>
        </tr>
        <tr>
          <td>FR</td>
          <td>75000</td>
          <td>FR</td>
          <td>33700</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit2">
            <th>21,12</th>
            <th>32,23</th>
            <th>43,34</th>
            <th>54,45</th>
            <th>65,56</th>
            <th>76,67</th>
            <th>87,78</th>
          </ng-container>
          <ng-template #KmUnit2>
            <th>2,35</th>
            <th>2,30</th>
            <th>2,20</th>
            <th>2,10</th>
            <th>2,00</th>
            <th>1,90</th>
            <th>1,80</th>
          </ng-template>
        </tr>
      </table>
      <br />
      <div class="h5">
        <mdb-icon fas icon="info-circle" class="info-text pr-2" aria-hidden="true"></mdb-icon>
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.RULES.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.RULES.PARAGRAPH_1"></p>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.RULES.PARAGRAPH_2"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.ZIP_CODE.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.ZIP_CODE.PARAGRAPH"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_STAR.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_STAR.PARAGRAPH"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_HASHTAG.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_HASHTAG.PARAGRAPH"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_BRACKETS.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_BRACKETS.PARAGRAPH"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_PIPE.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.CHARACTER_PIPE.PARAGRAPH"></p>
      <div class="h5">
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.SCORE.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.SCORE.PARAGRAPH"></p>
      <br />
      <div class="h5">
        <mdb-icon fas icon="info-circle" class="info-text pr-2" aria-hidden="true"></mdb-icon>
        <span jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.TITLE"></span>
      </div>
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.PARAGRAPH_1"></p>
      <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
        <tr class="bg-main">
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_1"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_2"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_3"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_4"></th>
          <ng-container *ngIf="!isRangePricing(); else rangePricing2">
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
          </ng-container>
          <ng-template #rangePricing2>
            <ng-container *ngIf="!isLDMUnit(); else LDMUnit2">
              <th>0-50</th>
              <th>51-100</th>
              <th>101-150</th>
              <th>151-200</th>
              <th>201-300</th>
              <th>301-400</th>
              <th>401-550</th>
            </ng-container>
            <ng-template #LDMUnit2>
              <th>0-0.4</th>
              <th>0.5-1.2</th>
              <th>1.3-2.4</th>
              <th>2.5-3.6</th>
              <th>3.7-4.8</th>
              <th>4.9-6</th>
              <th>6.1-7.2</th>
            </ng-template>
          </ng-template>
        </tr>
        <tr>
          <td>FR</td>
          <td>#337</td>
          <td>FR</td>
          <td>#33</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit3">
            <td>11,11</td>
            <td>22,22</td>
            <td>33,33</td>
            <td>44,44</td>
            <td>55,55</td>
            <td>66,66</td>
            <td>77,77</td>
          </ng-container>
          <ng-template #KmUnit3>
            <td>2,40</td>
            <td>2,35</td>
            <td>2,20</td>
            <td>2,10</td>
            <td>1,90</td>
            <td>1,80</td>
            <td>1,60</td>
          </ng-template>
        </tr>
        <tr>
          <td>FR</td>
          <td>33700</td>
          <td>FR</td>
          <td>#33</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit4">
            <td>21,12</td>
            <td>32,23</td>
            <td>43,34</td>
            <td>54,45</td>
            <td>65,56</td>
            <td>76,67</td>
            <td>87,78</td>
          </ng-container>
          <ng-template #KmUnit4>
            <td>2,35</td>
            <td>2,30</td>
            <td>2,20</td>
            <td>2,10</td>
            <td>2,00</td>
            <td>1,90</td>
            <td>1,80</td>
          </ng-template>
        </tr>
        <tr>
          <td>FR</td>
          <td>33700</td>
          <td>FR</td>
          <td>33000</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit5">
            <td>1,12</td>
            <td>2,23</td>
            <td>3,34</td>
            <td>4,45</td>
            <td>5,56</td>
            <td>6,67</td>
            <td>7,78</td>
          </ng-container>
          <ng-template #KmUnit5>
            <td>0,70</td>
            <td>0,65</td>
            <td>0,60</td>
            <td>0,55</td>
            <td>0,50</td>
            <td>0,45</td>
            <td>0,40</td>
          </ng-template>
        </tr>
        <tr>
          <td>FR</td>
          <td>33***</td>
          <td>FR</td>
          <td>75***</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit6">
            <td>10,01</td>
            <td>20,02</td>
            <td>30,03</td>
            <td>40,04</td>
            <td>50,05</td>
            <td>60,06</td>
            <td>70,07</td>
          </ng-container>
          <ng-template #KmUnit6>
            <td>2,00</td>
            <td>1,95</td>
            <td>1,90</td>
            <td>1,85</td>
            <td>1,80</td>
            <td>1,75</td>
            <td>1,70</td>
          </ng-template>
        </tr>
      </table>
      <br />
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.PARAGRAPH_2"></p>
      <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
        <tr class="bg-main">
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_1"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_2"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_3"></th>
          <th jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.ARRAY.COLUMN_4"></th>
          <ng-container *ngIf="!isRangePricing(); else rangePricing3">
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
          </ng-container>
          <ng-template #rangePricing3>
            <ng-container *ngIf="!isLDMUnit(); else LDMUnit7">
              <th>0-50</th>
              <th>51-100</th>
              <th>101-150</th>
              <th>151-200</th>
              <th>201-300</th>
              <th>301-400</th>
              <th>401-550</th>
            </ng-container>
            <ng-template #LDMUnit7>
              <th>0-0.4</th>
              <th>0.5-1.2</th>
              <th>1.3-2.4</th>
              <th>2.5-3.6</th>
              <th>3.7-4.8</th>
              <th>4.9-6</th>
              <th>6.1-7.2</th>
            </ng-template>
          </ng-template>
          <th class="bg-info">Score</th>
        </tr>
        <tr>
          <td>FR</td>
          <td>#337</td>
          <td>FR</td>
          <td>#33</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit7">
            <td>11,11</td>
            <td>22,22</td>
            <td>33,33</td>
            <td>44,44</td>
            <td>55,55</td>
            <td>66,66</td>
            <td>77,77</td>
          </ng-container>
          <ng-template #KmUnit7>
            <td>2,40</td>
            <td>2,35</td>
            <td>2,20</td>
            <td>2,10</td>
            <td>1,90</td>
            <td>1,80</td>
            <td>1,60</td>
          </ng-template>
          <td class="bg-info">3+2=5</td>
        </tr>
        <tr>
          <td>FR</td>
          <td>33700</td>
          <td>FR</td>
          <td>#33</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit8">
            <td>21,12</td>
            <td>32,23</td>
            <td>43,34</td>
            <td>54,45</td>
            <td>65,56</td>
            <td>76,67</td>
            <td>87,78</td>
          </ng-container>
          <ng-template #KmUnit8>
            <td>2,35</td>
            <td>2,30</td>
            <td>2,20</td>
            <td>2,10</td>
            <td>2,00</td>
            <td>1,90</td>
            <td>1,80</td>
          </ng-template>
          <td class="bg-info">5+2=7</td>
        </tr>
        <tr>
          <td>FR</td>
          <td>33700</td>
          <td>FR</td>
          <td>33000</td>
          <ng-container *ngIf="!isKmUnit(); else KmUnit9">
            <td>21,12</td>
            <td>32,23</td>
            <td>43,34</td>
            <td>54,45</td>
            <td>65,56</td>
            <td>76,67</td>
            <td>87,78</td>
          </ng-container>
          <ng-template #KmUnit9>
            <td>2,35</td>
            <td>2,30</td>
            <td>2,20</td>
            <td>2,10</td>
            <td>2,00</td>
            <td>1,90</td>
            <td>1,80</td>
          </ng-template>
          <td class="bg-info">5+5=10</td>
        </tr>
      </table>
      <br />
      <p jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.PARAGRAPH_3"></p>
      <p *ngIf="!isKmUnit()" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.PARAGRAPH_4_1"></p>
      <p *ngIf="isKmUnit()" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.EXAMPLES.PARAGRAPH_4_2"></p>
    </div>
  </div>
</div>
